import { render, staticRenderFns } from "./MRegisterEmailEditComp.vue?vue&type=template&id=80d75ada&scoped=true&"
import script from "./MRegisterEmailEditComp.vue?vue&type=script&lang=ts&"
export * from "./MRegisterEmailEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./MRegisterEmailEditComp.vue?vue&type=style&index=0&id=80d75ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d75ada",
  null
  
)

export default component.exports